var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AsyncModel } from './AsyncModel';
var AsyncTreeModel = /** @class */ (function (_super) {
    __extends(AsyncTreeModel, _super);
    function AsyncTreeModel(proxy, initialValue) {
        return _super.call(this, proxy, initialValue || []) || this;
    }
    AsyncTreeModel.prototype.getItemById = function (id) {
        var current;
        var visitors = this.getValue().slice();
        while ((current = visitors.pop())) {
            if (current.id === id) {
                return current;
            }
            if (Array.isArray(current.childs)) {
                visitors.push.apply(visitors, current.childs);
            }
        }
        return null;
    };
    return AsyncTreeModel;
}(AsyncModel));
export { AsyncTreeModel };
//# sourceMappingURL=AsyncTreeModel.js.map